import { APP_CONFIG } from '../config/app';

export function generateManifest() {
  return {
    short_name: APP_CONFIG.APP_SHORT_NAME,
    name: APP_CONFIG.APP_TITLE,
    description: APP_CONFIG.APP_DESCRIPTION,
    icons: [
      {
        src: "favicon.ico",
        sizes: "64x64 32x32 24x24 16x16",
        type: "image/x-icon",
        purpose: "any"
      },
      {
        src: "logo192.png",
        type: "image/png",
        sizes: "192x192",
        purpose: "any maskable"
      },
      {
        src: "logo512.png",
        type: "image/png",
        sizes: "512x512",
        purpose: "any maskable"
      }
    ],
    start_url: "/",
    display: "standalone",
    orientation: "portrait-primary",
    theme_color: "#1976d2",
    background_color: "#ffffff",
    scope: "/",
    categories: ["food", "restaurant", "integration"],
    lang: "en",
    dir: "ltr"
  };
}

export function updateManifest() {
  const manifest = generateManifest();
  const manifestBlob = new Blob([JSON.stringify(manifest, null, 2)], {
    type: 'application/json'
  });
  const manifestURL = URL.createObjectURL(manifestBlob);
  
  // Remove existing manifest link
  const existingManifest = document.querySelector('link[rel="manifest"]');
  if (existingManifest) {
    existingManifest.remove();
  }
  
  // Add new manifest link
  const manifestLink = document.createElement('link');
  manifestLink.rel = 'manifest';
  manifestLink.href = manifestURL;
  document.head.appendChild(manifestLink);
  
  // Update meta tags for better cross-platform support
  updateMetaTags();
}

export function updateMetaTags() {
  // Update application name meta tag
  const appNameMeta = document.querySelector('meta[name="application-name"]');
  if (appNameMeta) {
    appNameMeta.setAttribute('content', APP_CONFIG.APP_TITLE);
  }
  
  // Update Apple web app title
  const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleTitleMeta) {
    appleTitleMeta.setAttribute('content', APP_CONFIG.APP_SHORT_NAME);
  }
  
  // Update description
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', APP_CONFIG.APP_DESCRIPTION);
  }
}
